<template lang="pug">
  .hidden-header(
    v-lazyload
    :class="{ 'hidden-header_active': active }"
  )
    // left menu half
    .hidden-header__menu
      RouterLink.hidden-header__menu-item(
        v-for="item in leftMenu"
        :key="item.title"
        :class="{ 'hidden-header__menu-item_active': (item.to.hash || '').substr(1) === currentSection}"
        :to="{query: $route.query, ...item.to }"
      ) {{ item.title }}

    RouterLink.hidden-header__logo(:to="{query: $route.query, name: 'home'}")
      img(:src="logo")

    // right menu half
    .hidden-header__menu
      RouterLink.hidden-header__menu-item(
        v-for="item in rightMenu"
        :key="item.title"
        :class="{ 'hidden-header__menu-item_active': (item.to.hash || '').substr(1) === currentSection}"
        :to="{query: $route.query, ...item.to }"
      ) {{ item.title }}

      .header__menu-item.header__menu-item_feedback(v-tap="showModal")
        | {{ $t('header.feedback') }}
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import metricks from '@/mixins/metricks'

export default {
  name: 'HeaderHidden',
  mixins: [metricks],
  data: () => ({
    active: false,
    currentSection: null
  }),
  computed: {
    ...mapGetters('main', ['menu']),
    ...mapState('siteVersions', {
      currentSiteVersion: 'item'
    }),
    leftMenu: vm => vm.menu.slice(0, 3),
    rightMenu: vm => vm.menu.slice(3),
    logo: vm => vm.currentSiteVersion?.code === 'ar'
      ? require('@/assets/img/header/hidden/fixed_menu_logo_ar.png')
      : require('@/assets/img/header/hidden/fixed_menu_logo.png')
  },
  watch: {
    currentSection (value) {
      this.active = !!value
    }
  },
  mounted () {
    this.$nextTick(() => {
      const sections = document.querySelectorAll('main section')

      const listener = () => {
        this.currentSection = null

        sections.forEach(section => {
          if (section.style.display === 'none') {
            return false
          }

          const { top } = section.getBoundingClientRect()

          if (top <= window.innerHeight / 2) {
            this.currentSection = section.id
          }
        })
      }

      document.addEventListener('scroll', listener)
      listener()
    })
  },
  methods: {
    showModal () {
      this.$modal.show('ModalFeedback')
    }
  }
}
</script>
